const getDefaultState = () => {
  return {
    etapeEffective: [],
    etapeEffectiveDeAnimateur: [],

    //field: "name",
    //whereField: "role",
    //whereValue: "superviseur",
    collection: "etapes_effectives",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE(state, payload) {
    state.etapeEffective = payload;
  },
  SET_ETAPE_EFFECTIVE_DE_ANIMATEUR(state, payload) {
    state.etapeEffectiveDeAnimateur = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  ADD_ONE_ITEM(state, payload) {
    state.etapeEffectiveDeAnimateur.push(payload);
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  addOneItem({ commit }, item) {
    commit("ADD_ONE_ITEM", item);
    console.log("added to Vuex Etapes", item)
  },
  async get_etape_effective_by_parcours_et_etape({ commit }, payload) {
    // start requête

    commit("SET_LISTE", []);

    commit(
      "Loading/START_BUSY_STATE",
      "get_etape_effective_by_parcours_et_etape GetAll",
      {
        root: true,
      }
    );

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection(this.state.EtapeEffective.collection)
      .where(
        "parcours_effectif_id_parcours_effectif",
        "==",
        payload.IdParcoursEffectif
      )
      .where("etape_id_etape", "==", payload.idEtape)     
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            let text = "No Data Available";
            console.log(text);
            //start set snackbar
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = text;
            commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
            //End set snackbar
            commit(
              "Loading/END_BUSY_STATE",
              "get_etape_effective_by_parcours_et_etape No Data Available ",
              {
                root: true,
              }
            );
            return false;
          } else {
            commit("SET_LISTE", elems);
            commit(
              "Loading/END_BUSY_STATE",
              "get_etape_effective_by_parcours_et_etape ",
              {
                root: true,
              }
            );
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit(
            "Loading/END_BUSY_STATE",
            "get_etape_effective_by_parcours_et_etape error",
            {
              root: true,
            }
          );
        }
      );
  },
  async GetEtapeEffectiveDeAnimateur({ commit }, objet) {
    // start requête
    var start = this._vm
      .$moment(Date.now())
      .subtract(3, "months")
      .format("YYYY-MM-DD HH:mm:ss");
    var end = this._vm
      .$moment(Date.now())
      .add(3, "days")
      .format("YYYY-MM-DD HH:mm:ss");

    console.log("start :", start);
    console.log("end :", end);
    commit("SET_ETAPE_EFFECTIVE_DE_ANIMATEUR", []);

    commit(
      "Loading/START_BUSY_STATE",
      "EtapeEffectiveD GetEtapeEffectiveDeAnimateur",
      {
        root: true,
      }
    );

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection("etapes_effectives")
      .where("id_responsable", "==", objet.userId)
      .where("programmes_id_programme", "==", objet.project.id)
      .where("date_insert_etape_effective", ">=", start)
      .where("date_insert_etape_effective", "<=", end)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            let text = "No Data Available";
            console.log(text);
            //start set snackbar
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = text;
            commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
            //End set snackbar
            commit(
              "Loading/END_BUSY_STATE",
              "GetEtapeEffectiveDeAnimateur No Data Available ",
              {
                root: true,
              }
            );
            return false;
          } else {
            commit("SET_ETAPE_EFFECTIVE_DE_ANIMATEUR", elems);
            commit("Loading/END_BUSY_STATE", "GetEtapeEffectiveDeAnimateur", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit(
            "Loading/END_BUSY_STATE",
            "GetEtapeEffectiveDeAnimateur error",
            {
              root: true,
            }
          );
        }
      );
  },
};

const getters = {
  EtapeEffective: (state) => {
    return state.EtapeEffective;
  },
  EtapeEffectiveDeAnimateur: (state) => {
    return state.etapeEffectiveDeAnimateur;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
